<ng-template #illegal>
  <app-page403></app-page403>
</ng-template>

  <div *ngIf="showTable ; else logspin" >
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>
    

      <div class="col-md-4 text-right">
        <button class="btn btn-success btn-block" (click)="openPDF()">Download PDF</button>
      </div>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortStart="desc" id="reportData" data-cy="table-row">

        <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

       
        <ng-container matColumnDef="fileName">
          <th mat-header-cell *matHeaderCellDef>File Name or Target Name</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.analysis_status === 'No Data'; else linkRow">
              {{element.file_name}}
            </div>
            <ng-template #linkRow>
    
              <div *ngIf="element.analysis_status === 'Pending' && userAccess === 'qa' ; else showLink">
                {{element.file_name}}    
              </div>
              <ng-template #showLink>       
                <a
                [routerLink]="['/default-layout/qpcr-molecule-analysis', element.analysis_id, element.user_id, {type: 'audit'}]">{{element.file_name}}
              </a>
              </ng-template>

            </ng-template>

          </td>
        </ng-container>

        <ng-container matColumnDef="projectCode">
          <th mat-header-cell *matHeaderCellDef> Project Code</th>
          <td mat-cell *matCellDef="let element">{{element.project_code}}
        </ng-container>

        <ng-container matColumnDef="analysisDate">
          <th mat-header-cell *matHeaderCellDef> RedThread Analysis Date (UTC)</th>
          <td mat-cell *matCellDef="let element"> {{element.analysis_date}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status</th>
          <td mat-cell *matCellDef="let element"> {{element.analysis_status}} </td>
        </ng-container>
        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef> User ID </th>
          <td mat-cell *matCellDef="let element">{{element.user_id}}
        </ng-container>
        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef> RedThread User Name </th>
          <td mat-cell *matCellDef="let element">{{element.username}}
        </ng-container>
        <ng-container matColumnDef="userrole">
          <th mat-header-cell *matHeaderCellDef> User Role </th>
          <td mat-cell *matCellDef="let element">{{element.user_role}}
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
      </table>

  

    <mat-paginator [pageSizeOptions]="[ 10, 20, 50]" showFirstLastButtons></mat-paginator>
  </div>
  <ng-template #logspin>
    <div>
      <mat-spinner style="margin: 0 auto" mode="indeterminate" [diameter]="200"></mat-spinner>
    </div>
  </ng-template>

